var map = {
	"./historia/icon--historia.png": 9642,
	"./kultura/icon--kultura.png": 4104,
	"./motoryzacja/icon--motoryzacja.png": 7648,
	"./programowanie/icon--programowanie.png": 8320,
	"./technologia/icon--technologia.png": 7280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3095;